import {
    setHorizontalSrollEvent,
    setResizeEvent,
    scrollToActivatedTab,
} from './event/TabEvent';

export function activateTab(
    $depthListItems: NodeListOf<HTMLSpanElement> | null,
    activeDepth: Function,
    compareUrl?: string
): void {
    if (!$depthListItems) return;
    // for문 돌면서 활성화될 tabIndex 찾고, 찾을시 바로 break;

    for (let i = 0; i < $depthListItems.length; i++) {
        const $depthListItem = $depthListItems[i];
        const $depthATag = $depthListItem.children[0];

        if (
            findActiveHref(
                $depthATag.getAttribute('href') || '/',
                compareUrl || location.pathname,
                $depthATag.getAttribute('data-match-url')?.split(','),
                $depthATag.getAttribute('data-match-query')
            )
        ) {
            activeDepth($depthListItem, i);
            break;
        }
    }
}

// 활성화된 탭 찾기
export function findActiveHref(
    targetURL: string,
    compareURL: string,
    regexpArr?: (string | RegExp)[],
    queryString?: string | RegExp | null
) {
    // 탭이 쿼리에 의해서만 바뀌는 경우
    // queryString이 null 및 undefined가 아닌경우에만 실행
    if (typeof queryString === 'string')
        return useQueryFilterTab(queryString, targetURL);

    if (
        targetURL === compareURL ||
        regexpArr?.some((url) => new RegExp(url).test(compareURL))
    ) {
        return true;
    }
    return false;
}

const useQueryFilterTab = (queryString: string, targetURL: string) => {
    const regex = new RegExp(`[?&]${queryString}=([^&]+)`);
    const match = targetURL.match(regex);
    const compareQuery = match && match[1];
    return (
        compareQuery === new URLSearchParams(location.search).get(queryString)
    );
};

export const setEventHandlerAndScroll = (
    tabList: HTMLElement,
    activatedTab: HTMLElement,
    activatedTabIndex: number
) => {
    setHorizontalSrollEvent(tabList);
    setResizeEvent(tabList, activatedTab, activatedTabIndex);
    scrollToActivatedTab(activatedTab, activatedTabIndex, tabList);
};
